import { render, staticRenderFns } from "./Joey.vue?vue&type=template&id=4e5d99f6&scoped=true&"
import script from "./Joey.vue?vue&type=script&lang=js&"
export * from "./Joey.vue?vue&type=script&lang=js&"
import style0 from "./Joey.vue?vue&type=style&index=0&id=4e5d99f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d99f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
